const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
// const GetVesselReportByDate = 'IHSReports/GetVesselReportByDate'
// const GetVesselsInteractionsReport = 'IHSReports/GetVesselsInteractionsReport'
// const GetInspectionDashboardData = 'DPPReports/GetInspectionDashboardData'
const GetAllRoles = "UserManagement/GetAllRoles"
// const GetVessels = "DPPReports/GetVessels"
// const GetVesselInspections = "DPPReports/GetVesselInspections"
// const GetInspectionDetentionByMOU = "DPPReports/GetInspectionDetentionByMOU"
const GetCategoriesAndTypes = "Common/GetCategoriesAndTypes"
// const GetInspectionsByYear = "/DPPReports/GetInspectionsByYear"
// const GetMOUList = "/DPPReports/GetMOUlist"
// const GetFlagList = "/DPPReports/GetFlagList"
const GetCategorieTypesDescription = "Common/UpdateCategoriesAndTypes"
// const GetVesselTypeList = "DPPReports/GetVesselTypeList"
// const GetPorts = "DPPReports/GetPorts"
// const GetCountries = "DPPReports/GetCountries"
// const GetClassSocietyList = "DPPReports/GetClassSocietyList"
// const GetPSCInspectionStatsForFlags = 'DPPReports/GetPSCInspectionStatsForFlags'
// const GetFlagSavedDetentions = 'DPPReports/GetFlagSavedDetentions'
// const GetEncryptedString = 'DPPReports/GetEncryptedString'
// const GetInspectionsByVesselId = 'DPPReports/GetInspectionsByVesselId'
// const GetVesselCompanies = 'DPPReports/GetVesselCompanies'
// const GetCompanies = 'DPPReports/GetCompanies'
const GetUserHierarchy = 'UserHierarchy/GetUserHierarchy'


export const ApiUrls = {
  GetUsers,
  GetUserRoles,
  // GetCompanies,
  // GetVesselCompanies,
  SaveUserRoles,
  // GetVesselReportByDate,
  // GetVesselsInteractionsReport,
  // GetInspectionDashboardData,
  GetAllRoles,
  // GetVessels,
  // GetVesselInspections,
  GetCategoriesAndTypes,
  // GetInspectionDetentionByMOU,
  // GetInspectionsByYear,
  // GetInspectionsByVesselId,
  // GetMOUList,
  // GetFlagList,
  GetCategorieTypesDescription,
  // GetVesselTypeList,
  // GetPorts,
  // GetCountries,
  // GetClassSocietyList,
  // GetPSCInspectionStatsForFlags,
  // GetFlagSavedDetentions,
  // GetEncryptedString,
  GetUserHierarchy
}
